import { api } from '@/shared/api';

import type { ActualizePayload } from './types';

export const actualizeProducts = (
  products: ActualizePayload[],
  offerId: string,
) =>
  api.client.post(`/products/actualize`, {
    offer_id: offerId,
    products,
  });
